module.exports = __webpack_public_path__ + "img/axb.f925cd81.png";